// extracted by mini-css-extract-plugin
export default {"title":"style_title__JvTRv","subtitle":"style_subtitle__TtTid","group":"style_group__EST7-","actions":"style_actions__MdZVn","vertical":"style_vertical__+JYlV"};